<template>
  <div class="loading-state">
    <i class="el-icon-loading"></i>
    <span>加载中...</span>
  </div>
</template>

<script>
export default {
  name: 'LoadingState'
}
</script>

<style scoped>
.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: #6c757d;
  font-size: 14px;
}

.loading-state i {
  font-size: 24px;
  margin-bottom: 8px;
  color: #139AA5;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>